import React, { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';

import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid
} from '@material-ui/core';

import {
  PowerNow,
  TodayEnergy,
  MonthlyEnergy,
  YearlyEnergy,
  TotalEnergy
} from './components';

import mockData from './data';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    margin: 0,
    padding: 0
  }
}));

const MyPlaces = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const [tableData] = useState(mockData);

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item lg={3} sm={4} xl={3} xs={12}>
          <PowerNow />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <TodayEnergy />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <MonthlyEnergy />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <YearlyEnergy />
        </Grid>

        <Grid item lg={12} sm={6} xl={3} xs={12}>
          <Card {...rest}>
            <CardHeader title="My Places" />
            <Divider />
            <CardContent className={classes.content}>
              <PerfectScrollbar>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Power Now</TableCell>
                      <TableCell>Monthly Energy</TableCell>
                      <TableCell>Total Energy</TableCell>
                      <TableCell>Monthly Bill</TableCell>
                      <TableCell>Total Bill</TableCell>
                      <TableCell>View</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.map((data) => (
                      <TableRow hover key={data.name}>
                        <TableCell>{data.name}</TableCell>
                        <TableCell>{data.powerNow}</TableCell>
                        <TableCell>{data.monthlyEnergy}</TableCell>
                        <TableCell>{data.totalEnergy}</TableCell>
                        <TableCell>{data.monthlyBill}</TableCell>
                        <TableCell>{data.totalBill}</TableCell>
                        <TableCell>
                          <Link exact path="/dashboard">
                            view
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </PerfectScrollbar>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

MyPlaces.propTypes = {
  className: PropTypes.string
};

export default MyPlaces;
